import React, { useEffect, useRef } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import DeviceLogsContent from './DeviceLogsContent'
import './DeviceLogsModal.css'

function DeviceLogsModal({ deviceId, isOpen, onClose }) {
  const closeButtonRef = useRef(null)

  useEffect(() => {
    if (!isOpen) {
      return undefined
    }

    const previousOverflow = document.body.style.overflow
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose?.()
      }
    }

    document.body.style.overflow = 'hidden'
    document.addEventListener('keydown', handleKeyDown)
    window.setTimeout(() => closeButtonRef.current?.focus(), 0)

    return () => {
      document.body.style.overflow = previousOverflow
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [isOpen, onClose])

  if (!isOpen || !deviceId) {
    return null
  }

  const handleBackdropMouseDown = (event) => {
    if (event.target === event.currentTarget) {
      onClose?.()
    }
  }

  return (
    <div className="device-logs-modal" role="presentation" onMouseDown={handleBackdropMouseDown}>
      <section className="device-logs-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="device-logs-modal-title">
        <header className="device-logs-modal__header">
          <div>
            <span>CNERGI Device Logs</span>
            <h2 id="device-logs-modal-title">Logs</h2>
            <p>Device ID: {deviceId}</p>
          </div>
          <button className="device-logs-modal__close" type="button" aria-label="Close logs" onClick={onClose} ref={closeButtonRef}>
            <CloseIcon aria-hidden="true" />
          </button>
        </header>

        <div className="device-logs-modal__body">
          <DeviceLogsContent deviceId={deviceId} />
        </div>
      </section>
    </div>
  )
}

export default DeviceLogsModal
